/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import { Alert } from '../../../common/Alert/Alert'

/**
 *     Import
 *     - CSS
 */
import '../styles/UserAccount.css'

/**
 *     Form HTML
 */
const UserAccountFormHTML = (props) => {

    const {
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        errorState,
        goBack,
    } = props

    let errorList: any[] = []
    if (errorState !== null) { errorList.push(errorState._data) }
    let allFilled = (Object.keys(props.errors).length === 0) ? false : true

    return (
        <div>
            {(!!Object.keys(props.errors).length && !!Object.keys(props.touched).length) && (
                Object.keys(props.errors).filter(
                    (msg) => Object.keys(props.touched).includes(msg)
                ).map((error, idx) => {
                    const msg = props.errors[error]
                    errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                })
            )}

            {(errorList.length) ? (
                <Alert type="error">
                    {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                </Alert>
            ) : null}

            <form onSubmit={handleSubmit}>

                <div className="addUser__form__group form__w70">
                    <label className="active">Email</label>
                    <input
                        name="email"
                        id="email"
                        placeholder="Email"
                        type="text"
                        className={`form-control ${errors.email && touched.email && 'is-invalid'}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                    />
                </div>

                <div className="addUser__form__group">
                    <label className="active">First Name</label>
                    <input
                        name="firstName"
                        id="firstName"
                        type="text"
                        placeholder="First Name"
                        className={`form-control ${errors.firstName && touched.firstName && 'is-invalid'}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.firstName}
                    />
                </div>

                <div className="addUser__form__group">
                    <label className="active">Last Name</label>
                    <input
                        name="surname"
                        id="surname"
                        type="text"
                        placeholder="Last Name"
                        className={`form-control ${errors.surname && touched.surname && 'is-invalid'}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.surname}
                    />
                </div>

                <div className="addUser__form__group addUser__form__group--submit">
                    <Button half={true} onClick={goBack} type="button">Return to dashboard</Button>
                    <Button
                        half={true}
                        type="submit"
                        disabled={allFilled}
                    >
                        Save
                    </Button>
                </div>

            </form>
        </div>
    )
}

/**
 *     Formik Validation Struture
 */
export const UserAccountForm = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        email: props.email,
        firstName: props.firstName,
        surname: props.surname,
    }),

    validationSchema: Yup.object().shape({
        firstName: Yup.string().required('You need to add a first name'),
        surname: Yup.string().required('You need to add a last name'),
        email: Yup.string().email('Invalid email address').required('Email is required'),
    }),

    handleSubmit: (values, { props, setSubmitting }) => {
        let res = { user: values }
        props.saveAccountChangesTrigger(res)
    },

})(UserAccountFormHTML)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/UserAccount/components/UserAccount.form.tsx